import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TrainingPackage } from '@training/models/training/training-package.model';
import { AppStoreKeys } from 'src/app/store/store-keys.module';

import { RememberTrainingPackage, ResetTrainingPackage } from './training-package-state.actions';

export class TrainingPackageStateModel {
  readonly trainingPackage: TrainingPackage;
  readonly isLoadedSuccessfully: boolean;
}

@State<TrainingPackageStateModel>({
  name: AppStoreKeys.TrainingPackage,
  defaults: {
    trainingPackage: {
      id: '',
      documents: []
    },
    isLoadedSuccessfully: false
  }
})
@Injectable()
export class TrainingPackageState {
  @Selector()
  public static getState(state: TrainingPackageStateModel): TrainingPackageStateModel {
    return state;
  }

  @Selector()
  public static getTrainingPackageForAll(state: TrainingPackageStateModel): TrainingPackage {
    return state.trainingPackage;
  }

  @Action(RememberTrainingPackage)
  rememberTraining(context: StateContext<TrainingPackageStateModel>, action: RememberTrainingPackage): void {
    context.patchState({
      trainingPackage: action.payload,
      isLoadedSuccessfully: action.isLoadedSuccessfully
    });
  }

  @Action(ResetTrainingPackage)
  resetTraining(context: StateContext<TrainingPackageStateModel>): void {
    context.setState({
      trainingPackage: {
        id: '',
        documents: []
      },
      isLoadedSuccessfully: false
    });
  }
}
